import type { Vector3 } from 'three';
import type { IDisposable } from '@/engine/Utilities/IDisposable';
import type { PointerSyntheticEvent } from '@/components/viewPort/PointerSyntheticEvent';
import type * as THREE from 'three';

export interface IIndicationsController extends IDisposable {
  init: () => void;
  onPointAddAsync: (point: THREE.Vector3, event: PointerSyntheticEvent) => Promise<void>;
  onFinalize: () => void;
  onPointMove: (point: THREE.Vector3, event: PointerSyntheticEvent) => void;
}

export interface IIndicationStrategy extends IDisposable {
  onPointAddAsync: (point: Vector3, event: PointerSyntheticEvent) => Promise<void>;
  finalizeIndicationAsync?: () => Promise<void>;
  onPointMove?: (point: Vector3, event: PointerSyntheticEvent) => void;
}

export class IndicationsController implements IIndicationsController {
  private _strategy: IIndicationStrategy;

  public constructor(strategy: IIndicationStrategy) {
    this._strategy = strategy;
  }

  public init(): void {
    // noop
  }

  public dispose(): void {
    this._strategy.dispose();
  }

  public onPointAddAsync(point: Vector3, event: PointerSyntheticEvent): Promise<void> {
    return this._strategy.onPointAddAsync(point, event);
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises -- //TODO: [chebotarev] fix eslint no-misused-promises
  public async onFinalize(): Promise<void> {
    await this._strategy.finalizeIndicationAsync?.();
  }

  public onPointMove(point: Vector3, event: PointerSyntheticEvent): void {
    this._strategy.onPointMove?.(point, event);
  }
}
